import { gql } from '@apollo/client';

export default gql`
  mutation createMultiEvents($events: String) {
    createMultiEvents(events: $events) {
      ok
      message
      error
    }
  }
`;
